// extracted by mini-css-extract-plugin
export default {"home":"ReviewTaskListPage-styles-module--home--CvtPV"};